import { PartakerDTO } from "@/domain/definitions";
import { PartakerModel } from "@/domain/models/PartakerModel";

import { useAPIRequest } from "./useAPIRequest";
import { ref, Ref } from "vue";

const partakers = ref<PartakerModel[]>([]);

const usePartakers = (): {
  fetchPartakers: () => Promise<void>;
  partakers: Ref<PartakerModel[]>;
  isFetching: Ref<boolean>;
} => {
  const { execute, isFetching, data } =
    useAPIRequest<{ data: PartakerDTO[] }>("/partakers");

  async function fetchPartakers() {
    await execute();

    if (data.value) {
      partakers.value = data.value.data.map(
        (postDTO) => new PartakerModel(postDTO)
      );
    }
  }

  return { fetchPartakers, partakers, isFetching };
};
export default usePartakers;
